const setPushToken = (state, pushToken) => {
  state.pushToken = pushToken
}

export { setPushToken }
